import { PrinterPosOffIcon } from './PrinterPosOffIcon';

/**
 * author: Colton Wiscombe
 * id 50590358-DEC9-4F92-B1AF-0F005C35A3DA
 * name printer-pos-off
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-off.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptOffIcon = PrinterPosOffIcon;
export default PrinterReceiptOffIcon